import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_details_income",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "title-h4" }
const _hoisted_10 = { class: "row mb-5" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-1 mt-1" }
const _hoisted_13 = { class: "d-inline-block w-160" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-1 mt-1" }
const _hoisted_18 = { class: "d-inline-block w-160" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group mb-1 mt-1" }
const _hoisted_21 = { class: "d-inline-block w-160" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mb-1 mt-1" }
const _hoisted_24 = { class: "d-inline-block w-160" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group mb-1 mt-1" }
const _hoisted_27 = { class: "d-inline-block w-160" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group mb-1 mt-1" }
const _hoisted_30 = { class: "d-inline-block w-160" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = {
  key: 0,
  class: "form-group mb-1 mt-1"
}
const _hoisted_33 = { class: "d-inline-block w-160" }
const _hoisted_34 = {
  key: 1,
  class: "form-group mb-1 mt-1"
}
const _hoisted_35 = { class: "timeline-content" }
const _hoisted_36 = { class: "d-inline-block w-160" }
const _hoisted_37 = { class: "badges badges-bg badges-actif" }
const _hoisted_38 = { class: "col-md-12" }
const _hoisted_39 = { class: "form-group mb-1 mt-1" }
const _hoisted_40 = { class: "d-inline-block w-160" }
const _hoisted_41 = { class: "col-md-12" }
const _hoisted_42 = { class: "form-group mb-1 mt-1" }
const _hoisted_43 = { class: "d-inline-block w-160" }
const _hoisted_44 = { class: "row mb-3" }
const _hoisted_45 = { class: "col-md-12" }
const _hoisted_46 = { class: "title-h4" }
const _hoisted_47 = {
  key: 0,
  class: "tab-pane fade in active show",
  id: "members",
  style: {"overflow-x":"auto"}
}
const _hoisted_48 = { class: "datatables table table-striped table-bordered" }
const _hoisted_49 = { class: "thead-dark" }
const _hoisted_50 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_btn_delete = _resolveComponent("btn-delete")!
  const _component_not_found = _resolveComponent("not-found")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestIncomePayment)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('views.clients.income.payment.title')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_details_income', 'view'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.i18n.t('views.clients.income.payment.info')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("b", _hoisted_13, _toDisplayString(_ctx.i18n.t('tables.income.customer.title')), 1),
                _createTextVNode(" : "),
                (_ctx.income?.member_info)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.i18n.t('tables.income.customer.memberClub')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.i18n.t('tables.income.customer.foreignMember')), 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("b", _hoisted_18, _toDisplayString(_ctx.i18n.t('tables.members.name')), 1),
                _createTextVNode(" : " + _toDisplayString(_ctx.income?.memberName ?? ''), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("b", _hoisted_21, _toDisplayString(_ctx.i18n.t('tables.income.category_name')), 1),
                _createTextVNode(" : "),
                _createElementVNode("span", null, _toDisplayString(_ctx.income?.service?.category?.name ?? ''), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("b", _hoisted_24, _toDisplayString(_ctx.i18n.t('tables.income.service_name')), 1),
                _createTextVNode(": "),
                _createElementVNode("span", null, _toDisplayString(_ctx.income?.service?.name ?? ''), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("b", _hoisted_27, _toDisplayString(_ctx.i18n.t('tables.income.total_amount')), 1),
                _createTextVNode(": " + _toDisplayString(_ctx.income?.total_amount ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("b", _hoisted_30, _toDisplayString(_ctx.i18n.t('tables.income.total_amount_paid')), 1),
                _createTextVNode(" : " + _toDisplayString(_ctx.income?.total_amount_paid ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              (_ctx.income?.remaining_amount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("b", _hoisted_33, _toDisplayString(_ctx.i18n.t('tables.income.remaining_amount')), 1),
                    _createTextVNode(" : " + _toDisplayString(_ctx.income?.remaining_amount ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.income.remaining_amount <= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("p", _hoisted_35, [
                      _createElementVNode("b", _hoisted_36, _toDisplayString(_ctx.i18n.t('tables.subscription_member.remaining_amount')), 1),
                      _createTextVNode(": "),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.i18n.t('tables.subscription_member.paid')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("b", _hoisted_40, _toDisplayString(_ctx.i18n.t('tables.income.description')), 1),
                _createTextVNode(" : " + _toDisplayString(_ctx.income?.description ?? ''), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("b", _hoisted_43, _toDisplayString(_ctx.i18n.t('tables.income.date')), 1),
                _createTextVNode(" : " + _toDisplayString(_ctx.formatDate(_ctx.income?.date)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("h4", _hoisted_46, _toDisplayString(_ctx.i18n.t('views.clients.income.payment.paid')), 1)
            ])
          ]),
          (_ctx.incomesPaymentsList?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("table", _hoisted_48, [
                  _createElementVNode("thead", _hoisted_49, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.paymentDate')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.paymentMethod')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.chequeName')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.bankName')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.chequeNum')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.dueDate')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.payment.amount_paid')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.action')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incomesPaymentsList, (transaction, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        value: "member.id",
                        key: transaction?.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(transaction?.paymentDate)), 1),
                        _createElementVNode("td", null, _toDisplayString(transaction.paymentMethod), 1),
                        _createElementVNode("td", null, _toDisplayString(transaction.chequeName), 1),
                        _createElementVNode("td", null, _toDisplayString(transaction?.bankName), 1),
                        _createElementVNode("td", null, _toDisplayString(transaction?.chequeNum), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(transaction?.dueDate)), 1),
                        _createElementVNode("td", null, _toDisplayString(transaction?.amount_paid ?? 0.00) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_btn_delete, {
                            onDelete: ($event: any) => (_ctx.delet(transaction?.id, transaction?.amount_paid ?? 0))
                          }, null, 8, ["onDelete"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createVNode(_component_not_found, {
                  text: _ctx.i18n.t('message.data_not_found.title'),
                  icon: "warning"
                }, null, 8, ["text"])
              ]))
        ])
      ])
    ])
  ]))
}